<template>
  <div>
    <v-card>
      <v-system-bar dark color="grey darken-1" height="50">
        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-arrow-left-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        {{ groupe.nom_groupe }} - {{ projet.ll_programme }}
        <v-spacer></v-spacer>

        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-system-bar>
      <v-card-text>
        <v-btn
          v-if="user.role != 'operateur'"
          @click="printPresence()"
          block
          class="info rounded-pill my-4"
          ><v-icon class="mr-4">mdi-printer</v-icon> Imprimer fiche de
          présence</v-btn
        >
        <dialogNewFormation
          v-if="user.role != 'operateur'"
          :groupe="groupe"
          :projet="projet.ll_programme"
          :id="$route.params.id"
        />
        <template>
          <div class="text-center">
            <v-dialog v-model="dialogEditFormation" width="500">
              <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                  Edition de la formation
                </v-card-title>

                <v-card-text>
                  <v-form>
                    <v-text-field
                      v-model="formationSelected.ll_formation_groupe"
                      label="Formation"
                    ></v-text-field>

                    <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="computedDateFormation"
                          label="Date de la Formation"
                          prepend-icon="mdi-calendar-cursor"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        locale="fr"
                        v-model="formationSelected.date_formation_groupe"
                        no-title
                        @input="menu2 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-form>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-btn
                    rounded
                    color="warning"
                    @click="closeDialogEditFormation()"
                    >Annuler</v-btn
                  >
                  <v-btn rounded color="success" @click="doEditFormation()"
                    >Sauvegarder</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </template>

        <h2>
          Formations du projet {{ projet.ll_programme }}
          <span
            v-if="
              user.role != 'regionalFull' || user.role === 'regionalReadOnly'
            "
          >
            <span v-if="user.role !== 'operateur'"
              >(03 derniers mois)</span
            ></span
          >
        </h2>
        <v-list two-line subheader>
          <v-list-item
            v-for="(item, index) in _.filter(FormationsDeGroupeProjet, {
              groupes_code_groupe: groupe.id,
            })"
            :key="index"
            v-bind:class="item.dateFusion ? 'light-green-lighten-3' : ''"
          >
            <v-list-item-content style="padding: 20px;">
              <v-list-item-title
                v-html="item.ll_formation_groupe"
              ></v-list-item-title>
              <v-list-item-subtitle>
                Date de la formation :
                {{ $moment(item.date_formation_groupe).format("Do MMMM YYYY") }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                Activité : {{ item.ll_parcours }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                Projet : {{ item.ll_programme }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                Animateur : {{ item.nom_responsable }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
              Totaux  Femmes: {{ item.nbFemme }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                Totaux  Hommes: {{ item.nbHomme }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
              Détails  Femmes: {{ item.nbDetailFemme }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                Détails   Hommes: {{ item.nbDetailHomme }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                Total: {{ parseInt(item.nbHomme) + parseInt(item.nbFemme) }}/{{
                  MembresDuGroupeActifs.length
                }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="item.operateur">
                Vérifié par: {{ item.operateur }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="item.dateFusion">
                le: {{ $moment(item.dateFusion).format("Do MMMM YYYY") }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <div class="row">
                <div class="col mx-0 px-0 py-1">
                  <v-btn
                    @click="editFormation(item)"
                    class="mr-2"
                    fab
                    dark
                    x-small
                    color="warning"
                  >
                    <v-icon dark>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </div>
                <div
                  class="col mx-0 px-0 py-1"
                  v-if="
                    user.role === 'regionalFull' ||
                    user.role === 'regionalReadOnly'
                  "
                >
                  <v-btn
                    @click="deleteFormationAndPresence(item)"
                    class="mr-2"
                    fab
                    dark
                    x-small
                    color="danger"
                  >
                    <v-icon dark>
                      mdi-trash-can
                    </v-icon>
                  </v-btn>
                </div>
                <div class="col mx-0 px-0 py-1" v-if="user.role!='superviseur'">
                  <v-btn
                    class="mr-2"
                    fab
                    color="primary"
                    dark
                    x-small
                    @click="gotoPresenceFormationDeGroupe(item)"
                  >
                    <v-icon dark>mdi-chevron-right</v-icon>
                  </v-btn>
                </div>
                <!-- <div class="col mx-0 px-0 py-1" v-if="user.role!='superviseur' || user.isPaysanRelais">
                  <v-btn
                    class="mr-2"
                    fab
                    color="primary"
                    dark
                    x-small
                    @click="gotoPresenceFormationDeGroupe(item)"
                  >
                    <v-icon dark>mdi-chevron-right</v-icon>
                  </v-btn>
                </div> -->
              </div>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <!--   <v-list two-line subheader>
          <v-list-item
            v-for="(item, index) in _.filter(FormationsDeGroupeProjetapart, {
              groupes_code_groupe: groupe.id,
            })"
            :key="index"
          >
            <v-list-item-content
              @click="gotoPresenceFormationDeGroupe(item)"
              style="cursor: pointer;"
            >
              <v-list-item-title
                v-html="item.ll_formation_groupe"
              ></v-list-item-title>
              <v-list-item-subtitle>
                {{ $moment(item.date_formation_groupe).format("Do MMMM YYYY") }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ item.ll_programme }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ item.ll_parcours }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ item.nom_responsable }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <div class="row">
                <div class="col mx-0 px-0 py-1">
                  <v-btn
                    @click="editFormation(item)"
                    class="mr-2"
                    fab
                    dark
                    x-small
                    color="warning"
                  >
                    <v-icon dark>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </div>
                <div
                  class="col mx-0 px-0 py-1"
                  v-if="
                    user.role === 'regionalFull' ||
                    user.role === 'regionalReadOnly'
                  "
                >
                  <v-btn
                    @click="deleteFormationAndPresence(item)"
                    class="mr-2"
                    fab
                    dark
                    x-small
                    color="danger"
                  >
                    <v-icon dark>
                      mdi-trash-can
                    </v-icon>
                  </v-btn>
                </div>
                <div class="col mx-0 px-0 py-1">
                  <v-btn
                    class="mr-2"
                    fab
                    color="primary"
                    dark
                    x-small
                    @click="gotoPresenceFormationDeGroupe(item)"
                  >
                    <v-icon dark>mdi-chevron-right</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-list-item-action>
          </v-list-item>
        </v-list> -->
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {
    console.log("*******************************", this.user.role);
    //this.GetMembresDuGroupe(this.groupe.id);
    if (
      this.user.role === "regionalFull" ||
      this.user.role === "regionalReadOnly" ||
      this.user.role === "operateur"
    ) {
      var objet = {
        userId: this.groupe.responsable,
        project: this.projet,
        start: this.start,
        end: this.end,
      };
      this.GetFormationsDeGroupe(this.groupe.id);
      this.GetPresencesFormationsDeGroupeDuSuperviseur(objet);
      console.log("Je ne suis pas un animateur");
    } else {
      console.log("Je suis un animateur");
    }
  },
  data() {
    return {
      dialogEditFormation: false,
      formationSelected: { ll_formation_groupe: "", date_formation_groupe: "" },
      menu2: false,
      start: this.$moment(Date.now())
        .subtract(10, "years")
        .format("YYYY-MM-DD HH:mm:ss"),
      end: this.$moment(Date.now())
        .add(3, "days")
        .format("YYYY-MM-DD HH:mm:ss"),
    };
  },
  components: {
    etapesEffectives: require("@/components/groupes/etapesEffectives.vue")
      .default,
    vcol: require("@/components/groupes/col.vue").default,
    detailCampagne: require("@/components/groupes/detailCampagne.vue").default,
    dialogNewMembre: require("@/components/groupes/dialogNewMembre.vue")
      .default,
    dialogNewCampagne: require("@/components/groupes/dialogNewCampagne.vue")
      .default,
    dialogNewCycleGec: require("@/components/groupes/dialogNewCycleGec.vue")
      .default,
    dialogNewFormation: require("@/components/groupes/dialogNewFormation.vue")
      .default,
    dialogNewIntrant: require("@/components/groupes/dialogNewIntrant.vue")
      .default,
  },
  computed: {
    computedDateFormation() {
      return this.formationSelected.date_formation_groupe
        ? this.$moment(this.formationSelected.date_formation_groupe).format(
            "DD-MM-YYYY"
          )
        : "";
    },

    ...mapState({
      user: (state) => state.Auth.user,
      groupe: (state) => state.Groupes.itemById,
      MembresDugroupe: (state) => state.Membres.MembresDuGroupe,
      MembresDuGroupeActifs: (state) =>
        _.filter(state.Membres.MembresDuGroupe, { actif_dans_groupe: 1 }),
      ParcoursEffectif: (state) => state.ParcoursEffectif.ParcoursEffectif,
      FormationsDeGroupe: (state) =>
        state.FormationsDeGroupe.FormationsDeGroupe,
      FormationsDeGroupeProjet(state) {
        return _.filter(state.FormationsDeGroupe.FormationsDeGroupe, {
          programmes_id_programme: this.projet.id,
        });
      },
      FormationsDeGroupeProjetapart(state) {
        return _.reject(state.FormationsDeGroupe.FormationsDeGroupe, {
          programmes_id_programme: this.projet.id,
        });
      },
      DotationsDeGroupe: (state) => state.DotationsDeGroupe.DotationsDeGroupe,
      Campagnes: (state) => state.Campagnes.Campagnes,
      campagneActive: (state) => state.Campagnes.campagneActive,
      projet: function (state) {
        return _.filter(state.Projets.projets, {
          id: this.$route.query.idProjet,
        })[0];
      },
    }),
  },
  methods: {
    ...mapActions({
      GetFormationsDeGroupe: "FormationsDeGroupe/GetFormationsDeGroupe",
      GetMembresDuGroupe: "Membres/GetMembresDuGroupe",
      GetPresencesFormationsDeGroupeDuSuperviseur:
        "PresencesFormationsDeGroupe/GetPresencesFormationsDeGroupeDuSuperviseur",
    }),
    printPresence() {
      console.log("printPresence");
      var objectToSend = {
        membres: this.MembresDuGroupeActifs,
      };

      this.$router.push({
        name: "detailsGroupe-listeFormationsDeGroupe-print",
        params: objectToSend,
      });
    },
    editFormation(item) {
      console.log("editFormation", item);
      this.dialogEditFormation = true;
      this.formationSelected = item;
    },
    doEditFormation() {
      var self = this;
      var id = this.formationSelected.id;
      var lobjet = {
        ll_formation_groupe: self.formationSelected.ll_formation_groupe,
        date_formation_groupe: self.formationSelected.date_formation_groupe,
      };
      //Modifier Formation:
      var ref = this.$firebase
        .firestore()
        .collection("formationsDeGroupe")
        .doc(this.formationSelected.id);

      ref
        .set(lobjet, { merge: true })
        .then(() => {
          console.log("Formation modified ID: ", id);
          // Modifier Présences de la formation

          const PresencesFormations = self.$firebase
            .firestore()
            .collection("presencesFormationsGroupes");
          PresencesFormations.where(
            "formations_groupes_id_formation_groupe",
            "==",
            id
          )
            .get()
            .then((snapshots) => {
              console.log("PresencesFormations successfully updated!");
              if (snapshots.size > 0) {
                snapshots.forEach((snap) => {
                  PresencesFormations.doc(snap.id).set(lobjet, { merge: true });
                });
              } else {
                console.log("no snap presencesFormationsGroupes");
              }
            });
        })
        .catch((error) => {
          console.error("Error Editing document: ", error);
        });

      this.closeDialogEditFormation();
    },
    closeDialogEditFormation() {
      this.formationSelected = {
        ll_formation_groupe: "",
        date_formation_groupe: "",
      };
      this.dialogEditFormation = false;
    },
    deleteFormationAndPresence(item) {
      let self = this;
      var id = item.id;
      var idGroupe = item.groupes_code_groupe;
      const PresencesFormations = self.$firebase
        .firestore()
        .collection("presencesFormationsGroupes");
      this.$confirm(
        "Voulez vous vraiment supprimer la formation : <strong>" +
          item.ll_formation_groupe +
          "</strong> ?, et sa fiche de présence ?"
      ).then((res) => {
        if (res) {
          console.log("deleteFormationAndPresence", item);
          var ref = this.$firebase
            .firestore()
            .collection("formationsDeGroupe")
            .doc(item.id);

          ref
            .delete()
            .then(() => {
              PresencesFormations.where(
                "formations_groupes_id_formation_groupe",
                "==",
                id
              )
                .get()
                .then((snapshots) => {
                  console.log("PresencesFormations successfully deleted!");
                  if (snapshots.size > 0) {
                    snapshots.forEach((snap) => {
                      PresencesFormations.doc(snap.id).delete();
                    });
                  } else {
                    console.log("no snap presencesFormationsGroupes");
                  }
                });
              self.GetFormationsDeGroupe(idGroupe);
            })
            .catch((error) => {
              console.error("Error removing document: ", error);
            });
        }
      });
    },

    log(item) {
      console.log(item);
    },
    gotoPresenceFormationDeGroupe(item) {
      /* this.$router.push({ path: `/detailsGroupe/${item}` });*/
      // console.log(item)

      this.$router.push({
        path: `/groupes/presenceFormationGroupe/${item.id}`,
        query: {
          projet: this.$route.params.id,
          ll_formation_groupe: item.ll_formation_groupe,
          idAnimateur: item.responsable,
          id_groupe: item.groupes_code_groupe,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
